var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
import React from "react";
import shallowEqual from "./utils/shallowEqual";
import series from "./utils/series";
import whilst from "./utils/whilst";
import throttle from "./utils/throttle";
import uniqueId from "./utils/uniqueId";
import { innerWidth, innerHeight } from "./utils/innerSize";
function assertElementFitsWidth(el, width) {
    // -1: temporary bugfix, will be refactored soon
    return el.scrollWidth - 1 <= width;
}
function assertElementFitsHeight(el, height) {
    // -1: temporary bugfix, will be refactored soon
    return el.scrollHeight - 1 <= height;
}
function noop() { }
export var TextFit = (_a = /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1(props) {
            var _this = _super.call(this, props) || this;
            _this.pid = -1;
            _this._parent = null;
            _this._child = null;
            _this.state = {
                fontSize: _this.props.max,
                ready: false
            };
            _this.handleWindowResize = function () {
                _this.process();
            };
            if ("perfectFit" in props) {
                console.warn("TextFit property perfectFit has been removed.");
            }
            _this.handleWindowResize = throttle(_this.handleWindowResize, props.throttle);
            return _this;
        }
        class_1.prototype.componentDidMount = function () {
            var autoResize = this.props.autoResize;
            if (autoResize) {
                window.addEventListener("resize", this.handleWindowResize);
            }
            this.process();
        };
        class_1.prototype.componentDidUpdate = function (prevProps) {
            var ready = this.state.ready;
            if (!ready) {
                return;
            }
            if (shallowEqual(this.props, prevProps)) {
                return;
            }
            this.process();
        };
        class_1.prototype.componentWillUnmount = function () {
            var autoResize = this.props.autoResize;
            if (autoResize) {
                window.removeEventListener("resize", this.handleWindowResize);
            }
            // Setting a new pid will cancel all running processes
            this.pid = uniqueId();
        };
        class_1.prototype.process = function () {
            var _this = this;
            var _a = this.props, min = _a.min, max = _a.max, mode = _a.mode, forceSingleModeWidth = _a.forceSingleModeWidth, onReady = _a.onReady;
            var el = this._parent;
            var wrapper = this._child;
            if (el === null || wrapper === null) {
                console.warn("Can not process element without el and wrapper references.");
                return;
            }
            var originalWidth = innerWidth(el);
            var originalHeight = innerHeight(el);
            if (originalHeight <= 0 || isNaN(originalHeight)) {
                console.warn("Can not process element without height. Make sure the element is displayed and has a static height.");
                return;
            }
            if (originalWidth <= 0 || isNaN(originalWidth)) {
                console.warn("Can not process element without width. Make sure the element is displayed and has a static width.");
                return;
            }
            var pid = uniqueId();
            this.pid = pid;
            var shouldCancelProcess = function () { return pid !== _this.pid; };
            var testPrimary = mode === "multi"
                ? function () { return assertElementFitsHeight(wrapper, originalHeight); }
                : function () { return assertElementFitsWidth(wrapper, originalWidth); };
            var testSecondary = mode === "multi"
                ? function () { return assertElementFitsWidth(wrapper, originalWidth); }
                : function () { return assertElementFitsHeight(wrapper, originalHeight); };
            var mid = 0;
            var low = min;
            var high = max;
            this.setState({ ready: false });
            series([
                // Step 1:
                // Binary search to fit the element's height (multi line) / width (single line)
                function (stepCallback) { return whilst(function () { return low <= high; }, function (whilstCallback) {
                    if (shouldCancelProcess()) {
                        return whilstCallback(true);
                    }
                    mid = Math.floor((low + high) / 2);
                    _this.setState({ fontSize: mid }, function () {
                        if (shouldCancelProcess()) {
                            return whilstCallback(true);
                        }
                        if (testPrimary()) {
                            low = mid + 1;
                        }
                        else {
                            high = mid - 1;
                        }
                        return whilstCallback();
                    });
                }, stepCallback); },
                // Step 2:
                // Binary search to fit the element's width (multi line) / height (single line)
                // If mode is single and forceSingleModeWidth is true, skip this step
                // in order to not fit the elements height and decrease the width
                function (stepCallback) {
                    if (mode === "single" && forceSingleModeWidth) {
                        return stepCallback();
                    }
                    if (testSecondary()) {
                        return stepCallback();
                    }
                    low = min;
                    high = mid;
                    return whilst(function () { return low < high; }, function (whilstCallback) {
                        if (shouldCancelProcess()) {
                            return whilstCallback(true);
                        }
                        mid = Math.floor((low + high) / 2);
                        _this.setState({ fontSize: mid }, function () {
                            if (pid !== _this.pid) {
                                return whilstCallback(true);
                            }
                            if (testSecondary()) {
                                low = mid + 1;
                            }
                            else {
                                high = mid - 1;
                            }
                            return whilstCallback();
                        });
                    }, stepCallback);
                },
                // Step 3
                // Limits
                function (stepCallback) {
                    // We break the previous loop without updating mid for the final time,
                    // so we do it here:
                    mid = Math.min(low, high);
                    // Ensure we hit the user-supplied limits
                    mid = Math.max(mid, min);
                    mid = Math.min(mid, max);
                    // Sanity check:
                    mid = Math.max(mid, 0);
                    if (shouldCancelProcess()) {
                        return stepCallback(true);
                    }
                    _this.setState({ fontSize: mid }, stepCallback);
                }
            ], function (err) {
                // err will be true, if another process was triggered
                if (err || shouldCancelProcess()) {
                    return;
                }
                _this.setState({ ready: true }, function () { if (onReady) {
                    onReady(mid);
                } });
            });
        };
        class_1.prototype.render = function () {
            var _this = this;
            var _a = this.props, children = _a.children, text = _a.text, style = _a.style, min = _a.min, max = _a.max, mode = _a.mode, forceSingleModeWidth = _a.forceSingleModeWidth, 
            /* eslint-disable no-shadow */
            throttle = _a.throttle, 
            /* eslint-enable no-shadow */
            autoResize = _a.autoResize, onReady = _a.onReady, props = __rest(_a, ["children", "text", "style", "min", "max", "mode", "forceSingleModeWidth", "throttle", "autoResize", "onReady"]);
            var _b = this.state, fontSize = _b.fontSize, ready = _b.ready;
            var finalStyle = __assign(__assign({}, style), { fontSize: fontSize });
            var wrapperStyle = {
                display: ready ? "block" : "inline-block",
                whiteSpace: "normal"
            };
            if (mode === "single") {
                wrapperStyle.whiteSpace = "nowrap";
            }
            return (React.createElement("div", __assign({ ref: function (c) { return _this._parent = c; }, style: finalStyle }, props),
                React.createElement("div", { ref: function (c) { return _this._child = c; }, style: wrapperStyle }, text && typeof children === "function"
                    ? ready
                        ? children(text)
                        : text
                    : children)));
        };
        return class_1;
    }(React.Component)),
    _a.defaultProps = {
        min: 1,
        max: 100,
        mode: "multi",
        forceSingleModeWidth: true,
        throttle: 50,
        autoResize: true,
        onReady: noop
    },
    _a);
//# sourceMappingURL=TextFit.js.map